import { createContext, type ReactNode, useContext } from 'react'

const MobileProfileSlotContext = createContext<ReactNode>(null)

/**
 * Provides the mobile profile trigger to app screen layouts.
 */
export function MobileProfileSlotProvider(props: MobileProfileSlotProvider.Props) {
  const { children, value } = props

  return (
    <MobileProfileSlotContext.Provider value={value}>{children}</MobileProfileSlotContext.Provider>
  )
}

/**
 * Returns the mobile profile trigger for the current app shell.
 */
export function useMobileProfileSlot() {
  return useContext(MobileProfileSlotContext)
}

export declare namespace MobileProfileSlotProvider {
  /**
   * Props for the mobile profile slot provider.
   */
  type Props = {
    /** Nested app route content. */
    children: ReactNode
    /** Mobile profile trigger rendered in each screen header. */
    value: ReactNode
  }
}
